"use strict";
const { STRING } = require('../../../definitions/operandValueTypes');
exports.accepts = ({ valueType }) => valueType === STRING;
exports.parse = ({ value }) => {
    // Casting the value to a string through a template literal,
    // then ensuring the value to be compared is lowerCase.
    const parsedValue = `${value}`.toLowerCase();
    return parsedValue;
};
//# sourceMappingURL=stringParser.js.map